import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  message: '',
  type: ''
};

const messageSlice = createSlice({
  name: 'message',
  initialState,
  reducers: {
    setMessage: (state, action) => {
      return {
        ...state,
        message: action.payload.message,
        type: action.payload.type
      };
    },
    clearMessage: (state) => {
      return {
        ...state,
        message: '',
        type: ''
      };
    }
  }
});

const { reducer, actions } = messageSlice;

export const { setMessage, clearMessage } = actions;
export default reducer;
